export default {
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER',

  FILL_PROFILE: 'FILL_PROFILE',

  FILL_FUND: 'FILL_FUND',

  SET_HEADER_STATE: 'SET_HEADER_STATE',

  SET_DECODERS: 'SET_DECODERS',

  SET_ACTUAL_FUND: 'SET_ACTUAL_FUND',
  SET_ACTUAL_REEL: 'SET_ACTUAL_REEL'
}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js